export default __webpack_public_path__ + "static/media/BlogLight.e3f46b42.svg";